import TooltipComponent from "PFComponents/tooltip/tooltip";
import React, { PropsWithChildren } from "react";
import { useTranslation } from "react-i18next";

import css from "./overschedule_tooltip.module.scss";

export const OverscheduleTimeTooltip = ({ children }: PropsWithChildren) => {
  const { t } = useTranslation("bookingModule", { keyPrefix: "bookings" });

  return (
    <TooltipComponent
      content={
        <div className={css.tooltipRoot}>
          <div className={css.tooltipHeader}>{t("overscheduleTimeTooltip.header")}</div>
          <div>{t("overscheduleTimeTooltip.content")}</div>
        </div>
      }
    >
      {children}
    </TooltipComponent>
  );
};
